/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { defineMessages } from 'react-intl';

export const EndpointMessages = defineMessages({
  createYourBot: {
    id: 'MicrosoftTeams.EndpointMessages.messagingEndpoint',
    defaultMessage: 'Create your bot'
  },
  title: {
    id: 'MicrosoftTeams.EndpointMessages.title',
    defaultMessage: 'Bot information'
  },
  descriptionOne: {
    id: 'MicrosoftTeams.EndpointMessages.descriptionOne',
    defaultMessage:
      "Go to Microsoft's Azure portal and create an <link>Azure Bot</link> resource."
  },
  descriptionTwo: {
    id: 'MicrosoftTeams.EndpointMessages.descriptionTwo',
    defaultMessage:
      'Fill out the details to create the azure bot resource. Under <strong>Creation type</strong>, select <strong>Use existing app registration</strong> and enter the application ID of the app registration created in the previous tab. If you choose <strong>Create new Microsoft App ID</strong> you will need to update the application registration details in the previous page with the newly generated app registration.'
  },
  generatedEndpointLabel: {
    id: 'MicrosoftTeams.EndpointMessages.generatedEndpointLabel',
    defaultMessage: 'Generated endpoint'
  },
  descriptionThree: {
    id: 'MicrosoftTeams.EndpointMessages.descriptionThree',
    defaultMessage:
      'After your bot resource is created, go to Settings -> Configuration and paste the generated endpoint below in the <strong>Messaging endpoint</strong> field.'
  },
  multiTenant: {
    id: 'MicrosoftTeams.EndpointMessages.multiTenant',
    defaultMessage: 'Multi-Tenant'
  },
  descriptionFour: {
    id: 'MicrosoftTeams.EndpointMessages.descriptionFour',
    defaultMessage:
      "If you are configuring a Single-tenant app, select Single-tenant under the <strong>Bot type</strong> and enter the app registration's <strong>App Tenant ID</strong> as well. Click <strong>Apply</strong> to finish and go to <strong>Test in Web Chat</strong> to message with your assistant."
  },
  emptyClientId: {
    id: 'MicrosoftTeams.EndpointMessages.emptyClientId',
    defaultMessage: 'Fill in your application ID in the App registration tab.'
  }
});
